<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.displayName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ this.$store.state.auth.user.name }}</p>
      <small
        :class="{ 'role-switch-trigger': canSwitchRole }"
        @click="openRoleSwitchPopup"
      >
        {{ this.$store.state.auth.role.name }}
      </small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="
            this.$store.state.auth.user.photo === '/' ||
            !this.$store.state.auth.user.photo
              ? false
              : this.$store.state.auth.user
          "
          key="onlineImg"
          @error="onImageError"
          :src="this.$store.state.auth.user.photo"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <div
          v-else
          id="user_photo"
          class="rounded-full"
          style="width: 40px; height: 40px; background: rgb(195, 195, 195);"
        >
          <span
            translate="translate"
            class="vs-avatar--text notranslate material-icons person material-icons"
            style="transform: translate(-30%, -50%) scale(1); color: rgb(255, 255, 255);"
          >
            person
          </span>
        </div>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="triggerMenu('/user/profile')"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/email').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li> -->

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/todo').catch(() => {})">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li> -->

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/chat').catch(() => {})">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li> -->

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li> -->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-popup
      title="Trocar cargo"
      :active.sync="showRoleSwitchPopup"
      @update:active="onRolePopupUpdate"
    >
      <div class="p-4">
        <label class="vs-input--label">Selecione o cargo</label>
        <v-select
          v-model="selectedRole"
          class="w-full"
          :options="availableRoles"
          label="name"
          :reduce="role => role.hash"
          :clearable="false"
          append-to-body
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />

        <div class="flex justify-end mt-4">
          <vs-button
            type="border"
            color="dark"
            class="mr-2"
            @click="closeRoleSwitchPopup"
          >
            Cancelar
          </vs-button>
          <vs-button
            color="primary"
            :disabled="!selectedRole || isSwitchingRole"
            @click="submitRoleSwitch"
          >
            Trocar
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
// import firebase from "firebase/app";
// import "firebase/auth";
import { getApplicationLocalStorageItem } from "../../../../helpers";
import { getMsalInstanceMaster } from '../../../../authConfig.js';
import vSelect from 'vue-select';

export default {
  components: {
    vSelect
  },
  data() {
    return {
      showRoleSwitchPopup: false,
      selectedRole: null,
      isSwitchingRole: false
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    canSwitchRole() {
      return this.$store.state.auth.user.is_admin === true;
    },
    availableRoles() {
      return this.$store.state.auth.availableRoles || [];
    }
  },
  methods: {
    validUrl(url) {
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" +
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
          "((\\d{1,3}\\.){3}\\d{1,3}))" +
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
          "(\\?[;&a-z\\d%_.~+=-]*)?" +
          "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return !!pattern.test(url);
    },
    triggerMenu(route) {
      this.$router.push(route).catch(() => {});
      document.querySelector("#profile-menu").click();
    },
    async openRoleSwitchPopup() {
      if (!this.canSwitchRole) {
        return;
      }

      if (this.availableRoles.length === 0) {
        try {
          await this.$store.dispatch("auth/getSwitchableRoles");
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Erro",
            text: error.message || "Nao foi possivel carregar os cargos."
          });
          return;
        }
      }

      if (this.availableRoles.length > 0) {
        this.selectedRole =
          (this.$store.state.auth.role && this.$store.state.auth.role.identification) ||
          this.availableRoles[0].hash;
      }

      this.showRoleSwitchPopup = true;
    },
    closeRoleSwitchPopup() {
      this.showRoleSwitchPopup = false;
      this.isSwitchingRole = false;
    },
    onRolePopupUpdate(isActive) {
      if (!isActive) {
        this.isSwitchingRole = false;
      }
    },
    async submitRoleSwitch() {
      if (!this.selectedRole || this.isSwitchingRole) {
        return;
      }

      this.isSwitchingRole = true;

      try {
        const homeUrl = await this.$store.dispatch("auth/switchRole", this.selectedRole);
        this.closeRoleSwitchPopup();
        const baseUrl = process.env.BASE_URL.slice(0, -1);
        location.href = `${baseUrl}${homeUrl || "/"}`;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Erro",
          text: error.message || "Nao foi possivel trocar o cargo."
        });
      } finally {
        this.isSwitchingRole = false;
      }
    },
    onImageError() {
      this.$store.commit("auth/SET_USER_PHOTO", "/");
    },
    async logout() {
      if (getApplicationLocalStorageItem("accessToken")) {
        const useSSO = getApplicationLocalStorageItem('use_microsoft_sso')
        if(useSSO) {
          this.$store.dispatch("auth/signOut")
          .then(async () => {
            // this.$msal.logoutRedirect({ postLogoutRedirectUri: "http://localhost:8080/login-checker" });

            this.$msal.logoutRedirect({ postLogoutRedirectUri: "http://localhost:8080/login-checker" });
          })
        } else {
          this.$store.dispatch("auth/signOut")
          .then(() => this.$router.push("/login-checker").catch(() => {}))
        }
        // this.$vs.loading.close()
      }

      // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change("admin");
      // localStorage.removeItem("userInfo");

      // This is just for demo Purpose. If user clicks on logout -> redirect
      // this.$router.push("/login").catch(() => {});
    }
  }
};
</script>

<style scoped>
.role-switch-trigger {
  cursor: pointer;
  text-decoration: underline;
}
</style>
